import { render, staticRenderFns } from "./MySwiper.vue?vue&type=template&id=4464275b&scoped=true&"
import script from "./MySwiper.vue?vue&type=script&lang=js&"
export * from "./MySwiper.vue?vue&type=script&lang=js&"
import style0 from "./MySwiper.vue?vue&type=style&index=0&id=4464275b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464275b",
  null
  
)

export default component.exports